import type { FunctionComponent } from 'react';

import AdminVideoUpload from 'components/admin/VideoUpload';

import type { VideoT } from 'utils';

import IconInfo from 'assets/images/icon-info-24px.svg';

import S from './style.scss';

type PropsT = {
  localVideo: File | string | undefined;
  setLocalVideo: (video: File | string | undefined) => void;
  video: VideoT | null;
};

const UploadTab: FunctionComponent<PropsT> = ({
  localVideo,
  setLocalVideo,
  video,
}) => (
  <div
    className={S.container}

    // NOTE: These handlers are necessary to prevent the default browser
    // behavior for dropped-in videos / objects if the user slightly misses
    // the drop zone.
    onDragOver={(e) => {
      e.preventDefault();
    }}
    onDrop={(e) => {
      e.preventDefault();
    }}
  >
    <AdminVideoUpload
      localVideo={localVideo}
      setLocalVideo={setLocalVideo}
      video={video}
    />
    <div styleName="infoText">
      <IconInfo /> &zwnj;
      The video will be private until you published in the next step
    </div>
  </div>
);

export default UploadTab;
